import axios from "@/plugins/axios";

let url = "/api/v1/shop/review-images";

export default {
    gets(data) {
        return axios.get(url, data).then((result) => result.data);
    },
};
